enum PermissionLevels {
    GUEST,
    BASIC,
    PRO,
    ADMIN,
    EDITOR,
}

export { PermissionLevels };
